export const paths = {
  index: "/",
  auth: {
    login: "/auth/login",
    deleteMyAccount: "/auth/delete-my-account",
  },
  privacy: "/privacy",
  terms: "/terms",
  support: "/support",
  download: "/download",
  404: "/404",
};
